import Vue from "vue";
import VueRouter from "vue-router";
import Meta from 'vue-meta';
Vue.use(VueRouter);
Vue.use(Meta)

const routes = [
    // {
    //     path: "/",
    //     redirect: "/",
    // },
    {
        path: "/",
        name: "homePage",
        component: () => import(/* webpackChunkName: "HomePage" */ "../pages/HomePage"),
        meta: {
            title: 'Accueil - APAYM Cabine.',
            metaTags: [
                {
                    name: 'description',
                    content: 'Bienvenue sur votre Cabine Visa APAYM de rechargement de cartes Visa, proposée par APAYM.'
                },
                {
                    property: 'og:description',
                    content: 'Bienvenue sur votre Cabine Visa APAYM de rechargement de cartes Visa, proposée par APAYM.'
                }
            ]
        },
    },
    {
        path: "/rechargement-visa",
        name: "rechargementPage",
        redirect: "/",
        component: () => import(/* webpackChunkName: "RechargementPage" */ "../pages/RechargementPage"),
        meta: {
            title: 'Rechargement - APAYM Cabine.',
            metaTags: [
                {
                    name: 'description',
                    content: 'Bienvenue sur votre Cabine Visa APAYM de rechargement de cartes Visa, proposée par APAYM.'
                },
                {
                    property: 'og:description',
                    content: 'Bienvenue sur votre Cabine Visa APAYM de rechargement de cartes Visa, proposée par APAYM.'
                }
            ]
        },
    },
    {
        path: "/recu/:reference?",
        name: "receiptPage",
        component: () => import(/* webpackChunkName: "ReceiptPage" */ "../pages/ReceiptPage"),
        meta: {
            title: 'Reçu - APAYM Cabine.',
            metaTags: [
                {
                    name: 'description',
                    content: 'Mon reçu de rechargement. Votre Cabine Visa APAYM de rechargement de cartes Visa, proposée par APAYM.'
                },
                {
                    property: 'og:description',
                    content: 'Mon reçu de rechargement. Votre Cabine Visa APAYM de rechargement de cartes Visa, proposée par APAYM.'
                }
            ]
        },
    },
    {
        path: "/ref/:reference?",
        name: "refRechargementPage",
        component: () => import(/* webpackChunkName: "RefRechargementPage" */ "../pages/RefRechargementPage"),
        meta: {
            title: 'Recharge ma carte Visa - APAYM Cabine.',
            metaTags: [
                {
                    name: 'description',
                    content: 'Veuillez recharger ma carte Visa via Mobile Money sur APAYM Cabine.'
                },
                {
                    property: 'og:description',
                    content: 'Veuillez recharger ma carte Visa via Mobile Money sur APAYM Cabine.'
                }
            ]
        },
    },
    {
        path: "/return-rechargement/:reference?",
        name: "returnRechargementPage",
        component: () => import(/* webpackChunkName: "RefRechargementPage" */ "../pages/ReturnRechargementPage"),
        meta: {
            title: 'Recharge ma carte Visa - APAYM Cabine.',
            metaTags: [
                {
                    name: 'description',
                    content: 'Veuillez recharger ma carte Visa via Mobile Money sur APAYM Cabine.'
                },
                {
                    property: 'og:description',
                    content: 'Veuillez recharger ma carte Visa via Mobile Money sur APAYM Cabine.'
                }
            ]
        },
    },
    {
        path: "/achat-cartes",
        name: "achatCartesPage",
        component: () => import(/* webpackChunkName: "AchatCartePage" */ "../pages/AchatCartePage"),
        meta: {
            title: 'Achat de cartes Visa - APAYM Cabine.',
            metaTags: [
                {
                    name: 'description',
                    content: 'Bienvenue sur votre Cabine Visa APAYM d\'achat de cartes Visa, proposée par APAYM.'
                },
                {
                    property: 'og:description',
                    content: 'Bienvenue sur votre Cabine Visa APAYM d\'achat de cartes Visa, proposée par APAYM.'
                }
            ]
        },
    },
    {
        path: "/cartes",
        name: "achatCartesPage2",
        component: () => import(/* webpackChunkName: "AchatCartePage" */ "../pages/AchatCartePage"),
        meta: {
            title: 'Achat de cartes Visa - APAYM Cabine.',
            metaTags: [
                {
                    name: 'description',
                    content: 'Bienvenue sur votre Cabine Visa APAYM d\'achat de cartes Visa, proposée par APAYM.'
                },
                {
                    property: 'og:description',
                    content: 'Bienvenue sur votre Cabine Visa APAYM d\'achat de cartes Visa, proposée par APAYM.'
                }
            ]
        },
    },
    {
        path: "/recu-cartes/:reference?",
        name: "ReceiptCartesPage",
        component: () => import(/* webpackChunkName: "ReceiptCartesPage" */ "../pages/ReceiptCartesPage"),
        meta: {
            title: 'Reçu - APAYM Cabine.',
            metaTags: [
                {
                    name: 'description',
                    content: 'Mon reçu de rechargement. Votre Cabine Visa APAYM de rechargement de cartes Visa, proposée par APAYM.'
                },
                {
                    property: 'og:description',
                    content: 'Mon reçu de rechargement. Votre Cabine Visa APAYM de rechargement de cartes Visa, proposée par APAYM.'
                }
            ]
        },
    },
    
    {
        path: "*",
        name: "error404Page",
        component: () => import(/* webpackChunkName: "Error404Page" */ "../pages/Error404Page"),
        meta: {
            title: 'Page non trouvée - APAYM Cabine.',
            metaTags: [
                {
                    name: 'description',
                    content: 'Bienvenue sur votre Cabine Visa APAYM de rechargement de cartes Visa, proposée par APAYM.'
                },
                {
                    property: 'og:description',
                    content: 'Bienvenue sur votre Cabine Visa APAYM de rechargement de cartes Visa, proposée par APAYM.'
                }
            ]
        },
    }
];

const router = new VueRouter({
    routes,
    mode: "history",
});

router.beforeEach((to, from, next) => {

    window.document.title = to.meta.title ;
    next();

}) ;

router.afterEach(to => {
    localStorage.setItem("route", to.name);
    window.document.title = to.meta.title ;
});

export default router;
